module.exports = __webpack_public_path__ + "270805cee46d62bcc7cf83ed51267c29.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/RouteOnePower@2x.png
// module id = 49
// module chunks = 0